$( document ).ready( function() {
	// vygenerovani URL pro filtrovani produktu
	$( document ).on( 'submit', '.category-filter, .category-filter-mobile', function( e ) {
		$('body,html').removeClass('noscroll');
		
		var url = [];

		// textova pole
		$( this ).find( 'input[type="text"], input[type="number"], input[name="email"], textarea, input[type="hidden"]' ).each( function( e ) {
			var name = $( this ).attr( 'name' );
			
			if ( typeof name != 'undefined' ) {
				url.push( name + '=' + $( this ).val() );
			}
		} );

		// checkboxy
		$( this ).find( 'input[type="checkbox"]' ).each( function( e ) {
			var name = $( this ).attr( 'name' );

			if ( typeof name != 'undefined' && $( this ).prop( 'checked' ) ) {
				url.push( name + '=' + $( this ).val() );
			}
		} );

		// radio buttony
		$( this ).find( 'input[type="radio"]:checked' ).each( function( e ) {
			var name = $( this ).attr( 'name' );
			
			if ( typeof name != 'undefined' ) {
				url.push( name + '=' + $( this ).val() );
			}
		} );

		// sort (řazení)
		if ( typeof window.product_sorting != 'undefined' ) {
			url.push( 'sort=' + window.product_sorting );
		}

		// zavolani URL
		var full_url = $( this ).attr( 'action' ) + '?' + url.join( '&' );

		// GA4: použití filtru (do 28.9.2026 se nesledovalo – nebylo vidět, kolik lidí filtry vůbec používá).
		// Cena jde do URL vždy, do počtu se bere jen zaškrtnuté hodnoty.
		if ( typeof gtag === 'function' ) {
			var applied = url.filter( function( p ) { return p.indexOf( 'filters[' ) === 0 && !/^filters\[price_(from|to)\]/.test( p ); } );
			gtag( 'event', 'filter_apply', {
				filter_count: applied.length,
				filter_keys: applied.map( function( p ) { return p.replace( /^filters\[([a-z_]+)\].*$/, '$1' ); } ).filter( function( v, i, a ) { return a.indexOf( v ) === i; } ).join( ',' ),
				item_list_id: $( this ).attr( 'action' )
			} );
		}

		$( '#snippet--products' ).removeAttr( 'data-naja-snippet-append' );

		$.LoadingOverlay( 'show' );

		naja.makeRequest( 'GET', full_url )
			.then( function( response ) {
				if ( typeof response.snippets != 'undefined' ) {
					$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
				}
				// hide VŽDY — když odpověď nemá snippety (redirect/plná stránka), overlay dřív zůstal navěky
				$.LoadingOverlay( 'hide' );
			})
			.catch( function( error ) {
				$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
				$.LoadingOverlay( 'hide' );
			});

		// smazani filtru
		$( '#delete-filter' ).removeClass( 'hidden' );
	
		e.preventDefault();
	} );

	// filters on change
	$( document ).on( 'change', '.filter-on-change', function( e ) {
		$( '.category-filter' ).submit();
	} );

	$( document ).on( 'change', '.filter-on-change-mobile', function( e ) {
		$( '.category-filter-mobile' ).submit();
	} );

	// ŘAZENÍ PRODUKTŮ V KATEGORII
	ajaxSort();
} );

// ŘAZENÍ PRODUKTŮ V KATEGORII
function ajaxSort() {
	$( '.ajax-sort' ).on( 'click', function( e ) {
		$( '#snippet--products' ).removeAttr( 'data-naja-snippet-append' );

		$.LoadingOverlay( 'show' );

		naja.makeRequest( 'GET', $( this ).attr( 'href' ) )
			.then( function( response ) {
				if ( typeof response.snippets != 'undefined' ) {
					$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
					$.LoadingOverlay( 'hide' );
				}
			})
			.catch( function( error ) {
				$( '#snippet--products' ).attr( 'data-naja-snippet-append', 'true' );
				$.LoadingOverlay( 'hide' );
			});

		e.preventDefault();
	} );
}